
import {computed, onMounted, onUpdated, ref, getCurrentInstance} from 'vue';
import { useStore } from 'vuex';
import { variantGrouping } from 'Vue/interfaces/ProductFilteringInterfaces';
import { useToast } from 'vue-toastification';
const toast = useToast();
import slugify from 'slugify';
import { IProductFilteringTranslations } from 'Vue/interfaces/Interfaces';

export default {
	name: 'ProductCard',
	props: {
		url: String,
		title: String,
		imageUrl: String,
		beautyImageUrl: String,
		description: String,
		numberOfFinishes: Number,
		availability: String,
		modelNumber: String,
		index: Number,
		isFinishImageMissing: Boolean,
		isDiscontinued: Boolean,
		product: {
			type: Object,
			default: {} as variantGrouping,
		},
		translations: {
			type: Object,
			default: {} as IProductFilteringTranslations,
		},
	},
	setup(props) {
		const store = useStore();
		const addedToFavorites = ref(false);
		const isSelected = ref(false);
		const instance = getCurrentInstance();
		const avblActive = ref('active');
		const avblNew = ref('new');
		const avblDiscontinued = ref('discontinued');
		const avblComingSoon = ref('coming-soon');
		const fallbackImage = ref('https://images.weiserlock.com/is/image/Weiser/imagenotavailable2?wid=400');

		const setFavorites = () => {
			let productIds = getFavoriteProducts();
			if (props.product.variantSlug != null) {
				if (productIds.indexOf(props.product.variantSlug) > -1) {
					addedToFavorites.value = true;
				} else {
					addedToFavorites.value = false;
				}
			}
		};

		const addremoveFavorites = (event, product) => {
			event.preventDefault();
			addedToFavorites.value = !addedToFavorites.value;
			let productIds = getFavoriteProducts();
			if (product.variantSlug != null) {
				if (productIds.indexOf(product.variantSlug) < 0) {
					productIds.push(product.variantSlug);
				} else {
					productIds.splice(productIds.indexOf(product.variantSlug), 1);
					// Method to trigger removal of the favorite products when on wishlist page
					instance.emit('favoriteItemRemoved', product);
				}
				localStorage.setItem('wishlist-products', JSON.stringify(productIds));
			}

			// This event triggers the Favorites counter in the nav to update
			window.dispatchEvent(new Event('favorites'));
		};

		const getFavoriteProducts = (): string[] => {
			let productIds: string[] = [];
			if (localStorage.getItem('wishlist-products')) {
				productIds = JSON.parse(localStorage.getItem('wishlist-products'));
			}
			return productIds;
		};

		const addOrRemoveFromArray = (product) => {
			//product is already in array
			if (store.state?.comparisonItems.filter((p) => p.slug === product.slug).length) {
				let index = store.state?.comparisonItems.indexOf(product);
				store.commit('removeProductFromComparison', index);
				//product is not in the array yet
			} else {
				if (store.state?.comparisonItems?.length <= 4) {
					store.commit('addProductToComparison', product);
				}
			}
		};

		const preventBubble = (event) => {
			event.stopPropagation();
			if (store.state?.comparisonItems?.length >= 5 && event.target.classList.contains('disabled')) {
				toast.error(`No more than 5 items allowed for comparison`, {
					timeout: 5000,
				});
			}
		};

		const inComparisonItemsArray = computed(() => {
			return !!store.getters?.comparisonItems?.filter((p) => p.slug === props.product.slug).length;
		});

		const maxCapacity = computed(() => {
			return store.getters?.comparisonItems?.length === 5 && inComparisonItemsArray.value === false;
		});

		const availabilitySlug = computed(() => {
			return props.availability
				? slugify(props.availability, {
					lower: true, // convert to lower case, defaults to `false`
					strict: true, // strip special characters except replacement, defaults to `false`
					remove: /[*+~.()'"!:@]/g,
				})
				: '';
		});

		onMounted(() => {
			setFavorites();
		});

		onUpdated(() => {
			setFavorites();
		});

		return {
			isSelected,
			avblActive,
			avblNew,
			avblDiscontinued,
			avblComingSoon,
			addedToFavorites,
			setFavorites,
			addremoveFavorites,
			addOrRemoveFromArray,
			preventBubble,
			maxCapacity,
			availabilitySlug,
			fallbackImage,
			inComparisonItemsArray
		}
	}
};
